import { adaptToDatabase } from '../../../utils/adaptToDatabase'
import { unifyParams } from '../../../utils/unifyParams'
import apinode from '../../apinode'

class ReclamacoesService {
  constructor() {
    this.idconta = localStorage.idconta
  }

  async getAll(startDate, endDate) {
    let url = unifyParams(`/claims/${this.idconta}`, [
      {
        key: 'startDate',
        value: startDate,
      },
      {
        key: 'endDate',
        value: endDate,
      },
    ])

    const response = await apinode.get(url)

    return response.data
  }

  async getByCode(code) {
    const response = await apinode.get(`/claims/${code}/${this.idconta}`)

    return response.data
  }

  async getByOrderId(pedido) {
    const response = await apinode.get(
      `/claims/pedido/${pedido}/${this.idconta}`,
    )

    return response.data
  }

  async getStatus() {
    const response = await apinode.get(`/claims/get_status/${this.idconta}`)

    return response.data.status
  }

  async sync({ from, to }) {
    const response = await apinode.patch(
      `/claims/sync/${this.idconta}?from=${from}&to=${to}`,
    )

    return response.data
  }

  async create(data) {
    const dataFormatted = adaptToDatabase(data, [
      'taxa_envio',
      'taxa_retorno',
      'debito_ml',
      'credito_ml',
    ])

    await apinode.post(`/claims/${this.idconta}`, dataFormatted)
  }

  async update(id, data) {
    const dataFormatted = adaptToDatabase(data, [
      'taxa_envio',
      'taxa_retorno',
      'debito_ml',
      'credito_ml',
    ])

    await apinode.put(`/claims/${id}/${this.idconta}`, dataFormatted)
  }

  async delete(code) {
    await apinode.delete(`/claims/${code}/${this.idconta}`)
  }
}

export default new ReclamacoesService()
